module.exports = __webpack_public_path__ + "static/img/btn_bgc_3.0e6aa4c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/latast_pc/btn_bgc_3.png
// module id = 7Dci
// module chunks = 98